import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { UrgencyBadge } from './ui/UrgencyBadge';
import { Check, Star } from 'lucide-react';
interface PricingCardProps {
  title: string;
  subtitle?: string;
  price: string;
  oldPrice?: string;
  features?: string[];
  buttonText: string;
  isPopular?: boolean;
  onCtaClick?: () => void;
  href?: string;
  className?: string;
}
export function PricingCard({
  title,
  subtitle,
  price,
  oldPrice,
  features,
  buttonText,
  isPopular,
  onCtaClick,
  href,
  className
}: PricingCardProps) {
  return <Card className={`relative flex flex-col h-full ${isPopular ? 'border-honey border-2 shadow-soft' : 'border-sage-mist'} ${className}`} data-id="element-324">
      {isPopular && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-honey text-forest-deep px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider flex items-center gap-1 shadow-md" data-id="element-325">
          <Star className="w-3 h-3 fill-current" data-id="element-326" />
          MÁS ELEGIDO
        </div>}

      <div className={`p-6 md:p-8 flex-grow flex flex-col ${isPopular ? 'bg-honey/5' : 'bg-white'}`} data-id="element-327">
        <div className="text-center mb-6" data-id="element-328">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-forest-deep mb-2 flex items-center justify-center gap-2" data-id="element-329">
            {isPopular && <span className="text-honey" data-id="element-330">⭐</span>}
            {title}
          </h3>
          {subtitle && <p className="text-sm text-forest/70 mb-4" data-id="element-331">{subtitle}</p>}

          <div className="flex flex-col items-center justify-center mt-4" data-id="element-332">
            {oldPrice && <span className="text-forest/60 line-through text-sm mb-1" data-id="element-333">
                ANTES: {oldPrice}
              </span>}
            <div className="flex items-baseline gap-1" data-id="element-334">
              {oldPrice && <span className="text-sm font-bold text-honey-dark mr-2" data-id="element-335">
                  HOY:
                </span>}
              <span className="text-3xl md:text-4xl font-bold text-forest-deep" data-id="element-336">
                {price}
              </span>
              <span className="text-sm text-forest/70 font-medium" data-id="element-337">ARS</span>
            </div>
          </div>
        </div>

        {features && features.length > 0 && <div className="mb-8 flex-grow" data-id="element-338">
            <ul className="space-y-3" data-id="element-339">
              {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-340">
                  <div className="mt-0.5 bg-moss/10 rounded-full p-0.5 shrink-0" data-id="element-341">
                    <Check className="w-4 h-4 text-moss" data-id="element-342" />
                  </div>
                  <span className="text-sm text-forest-deep leading-tight" data-id="element-343">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </div>}

        <div className="mt-auto pt-4" data-id="element-344">
          <div className="flex justify-center mb-3" data-id="element-345">
            <UrgencyBadge variant={isPopular ? 'fire' : 'clock'} tone="dark" label={isPopular ? 'OFERTA LIMITADA' : 'CIERRA HOY'} data-id="element-346" />
          </div>
          {href ? <Button variant="cta" fullWidth size="lg" href={href} className="text-sm md:text-base" data-id="element-347">
              {buttonText}
            </Button> : <Button variant="cta" fullWidth size="lg" onClick={onCtaClick} className="text-sm md:text-base" data-id="element-348">
              {buttonText}
            </Button>}
        </div>
      </div>
    </Card>;
}